

















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import learningRequestsV2, {
  LearningRequestsListParamsV2
} from "@/getinfo-api/learningRequestsV2";
import { getCurrentCompanyId } from "@/plugins/roles";
import { LearningRequest as ILearningRequestV2 } from "@/api-v2/learning-requests/models";
import CustomTable from "@/components/form/CustomTable.vue";
import { StatusProfile as IProfile } from "@/api-v2/learning-requests/models";
import LearningRequestTableItem from "@/components/learning-request-v2/LearningRequestTableItem.vue";
import { learningRequestApi } from "@/getinfo-api";
import { LearningRequestSort, SortFields } from "@/plugins/sort-fields";

@Component({ components: { LearningRequestTableItem, CustomTable } })
export default class LearningRequestTable extends Vue {
  @Prop() params!: LearningRequestsListParamsV2;
  learningRequests: ILearningRequestV2[] = [];
  count: number = 0;
  profiles: Array<IProfile> = [];
  localParams: LearningRequestsListParamsV2 = {
    limit: 30,
    sort: "formedAt",
    order: "DESC"
  };
  pageNumber: number = 1;
  isLoading: boolean = false;
  sorted: SortFields<LearningRequestSort> = new SortFields(
    LearningRequestSort.formedAt
  );
  @Watch("params", { deep: true })
  checkParams() {
    this.pageNumber = 1;
    this.localParams.offset = 0;
    this.localParams.limit = 30;
    this.localParams = {
      ...this.localParams,
      ...this.params
    };
    if (this.localParams.formedAtMax?.getDay().toString() === "NaN") {
      this.localParams.formedAtMax = undefined;
    }
    if (this.localParams.formedAtMin?.getDay().toString() === "NaN") {
      this.localParams.formedAtMin = undefined;
    }
    this.getLearningRequests();
  }

  get sortStatus() {
    return LearningRequestSort;
  }

  getLearningRequests() {
    this.isLoading = true;
    learningRequestsV2(this.localParams)
      .then(res => {
        this.count = res.data.count;
        this.learningRequests = res.data.items;
        this.$emit("getCount", this.count);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  changePage() {
    this.$nextTick(() => {
      this.learningRequests = [];
      if (this.localParams && this.localParams.limit) {
        this.localParams.offset =
          this.localParams.limit * (this.pageNumber - 1);
        this.getLearningRequests();
      }
    });
  }

  getProfiles() {
    learningRequestApi.StatusProfiles.listProfiles(this.selectedCompanyId).then(
      res => {
        this.profiles = res.data;
      }
    );
  }

  getProfileById(id: string) {
    let index = this.profiles.findIndex(el => el.id === id);
    return this.profiles[index];
  }

  acceptSort(sort: LearningRequestSort) {
    this.sorted.changeSort(sort);
    this.localParams.sort = this.sorted.sort;
    this.localParams.order = this.sorted.order;
    this.getLearningRequests();
  }

  created() {
    this.getLearningRequests();
    this.getProfiles();
  }
}
